<div class="row align-items-center mt-5">
    <div class="col-6">
        <b>{{ l('Activity') }}</b>
    </div>

    <div class="col-6">
        <b>{{ l('Resource') }}</b>
    </div>
</div>

<div class="row align-items-center mt-5"
     *ngIf="!allocationLoading && !activityDays.length;">
    <div class="col-12">
        <div class="alert alert-info">
            {{ l('NoData') }}
        </div>
    </div>
</div>

<div *ngIf="!allocationLoading && activityDays.length">
    <div class="row align-items-center mt-5" *ngFor="let day of activityDays">
        <div class="col-12">
            <app-allocation-activity-item
                [day]="day"
                [allocationSheetId]="allocationSheetId"
                (openActivityPanel)="openActivityDetailsPanel($event)"
                (onRemoveFromAllocation)="reload()">
            </app-allocation-activity-item>
        </div>
    </div>
</div>

<app-activities-add-button *ngIf="isGranted('Pages.Activities.Create')"></app-activities-add-button>

<app-clone-activities-modal
    #cloneActivityModal
    (afterActivityCloned)="afterClone()"
>
</app-clone-activities-modal>

<app-activities-drawer
    [activityData]="activityData"
    (refreshData)="refresh()"
    [cloneModal]="modal"
    [context]="'allocation'">
</app-activities-drawer>

